const roleMap = {
  platform: {
    label: "平台管理员后台",
    accountName: "平台管理员",
    homePath: "/platform/dashboard",
    menus: [
      { label: "首页", children: [{ path: "/platform/dashboard", label: "首页" }] },
      {
        label: "供应商",
        children: [
          { path: "/platform/suppliers/create", label: "新增供应商" },
          { path: "/platform/suppliers/list", label: "供应商列表" },
          { path: "/platform/suppliers/payment-config", label: "支付配置" }
        ]
      },
      {
        label: "学校",
        children: [
          { path: "/platform/schools/create", label: "新增学校" },
          { path: "/platform/schools/list", label: "学校列表" }
        ]
      },
      {
        label: "教材",
        children: [
          { path: "/platform/textbooks/create", label: "新增教材" },
          { path: "/platform/textbooks/list", label: "教材列表" }
        ]
      },
      {
        label: "订单",
        children: [
          { path: "/platform/orders/overview", label: "订单概览" },
          { path: "/platform/orders/list", label: "订单列表" },
          { path: "/platform/orders/verify", label: "订单核销" }
        ]
      },
      {
        label: "统计与分析",
        children: [
          { path: "/platform/analytics/term", label: "按学期统计" },
          { path: "/platform/analytics/suppliers", label: "按供应商统计" },
          { path: "/platform/analytics/schools", label: "按学校统计" }
        ]
      }
    ]
  },
  supplier: {
    label: "供应商管理员后台",
    accountName: "供应商管理员",
    homePath: "/supplier/dashboard",
    menus: [
      { label: "首页", children: [{ path: "/supplier/dashboard", label: "首页" }] },
      {
        label: "学校",
        children: [
          { path: "/supplier/schools/create", label: "新增学校" },
          { path: "/supplier/schools/list", label: "学校列表" }
        ]
      },
      {
        label: "教材",
        children: [
          { path: "/supplier/textbooks/create", label: "新增教材" },
          { path: "/supplier/textbooks/list", label: "教材列表" }
        ]
      },
      {
        label: "订单",
        children: [
          { path: "/supplier/orders/overview", label: "订单概览" },
          { path: "/supplier/orders/summary", label: "订单汇总" },
          { path: "/supplier/orders/list", label: "订单列表" },
          {
            label: "订单核销",
            children: [
              { path: "/supplier/orders/print-slip", label: "打印领书单" },
              { path: "/supplier/orders/verify", label: "订单核销" }
            ]
          }
        ]
      },
      {
        label: "统计与分析",
        children: [
          { path: "/supplier/analytics/term", label: "按学期统计" },
          { path: "/supplier/analytics/schools", label: "按学校统计" }
        ]
      }
    ]
  },
  school: {
    label: "学校管理员后台",
    accountName: "学校管理员",
    homePath: "/school/dashboard",
    menus: [
      { label: "首页", children: [{ path: "/school/dashboard", label: "首页" }] },
      {
        label: "学生",
        children: [
          { path: "/school/students/import", label: "新增学生" },
          { path: "/school/students/list", label: "学生列表" },
          { path: "/school/students/rebind", label: "学生换绑审批" }
        ]
      },
      {
        label: "课程",
        children: [
          { path: "/school/courses/import", label: "新增课程" },
          { path: "/school/courses/list", label: "课程列表" }
        ]
      },
      {
        label: "教材",
        children: [
          { path: "/school/textbooks/import", label: "教材征订" },
          { path: "/school/textbooks/list", label: "教材列表" }
        ]
      },
      {
        label: "统计与分析",
        children: [
          { path: "/school/analytics/overview", label: "统计概览" }
        ]
      }
    ]
  }
};

const state = {
  currentRole: "platform",
  currentTerm: "2026-2027 学年秋季学期",
  currentUser: null,
  roles: roleMap
};

const mutations = {
  SET_SEMESTER(currentState, value) {
    currentState.currentTerm = value;
  },
  SET_ROLE(currentState, role) {
    if (currentState.roles[role]) {
      currentState.currentRole = role;
    }
  },
  SET_CURRENT_USER(currentState, user) {
    currentState.currentUser = user || null;
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
